export const products = {
  rush: {
    id: 'rush',
    title: 'RUSH',
    subtitle: 'Instant Focus & Lasting Energy',
    description: 'A powerful blend of adaptogenic herbs and functional mushrooms designed to enhance focus, energy, and mental clarity without the crash.',
    price: 48.99,
    originalPrice: 68.99,
    image: '/products/rush-1.png',
    images: ['/products/rush-1.png', '/products/rush-2.png', '/products/rush-3.png'],
    servingSize: '2 Capsules',
    servingsPerContainer: 30,
    supplyDays: 30,
    sku: '47034-838',
    ingredients: [
      { name: 'Cordyceps Powder', amount: '266mg', description: 'Supports energy and endurance' },
      { name: 'Reishi Mushroom Extract', amount: '266mg', description: 'Promotes calm focus and immune support' },
      { name: 'Shiitake Mushroom Extract', amount: '266mg', description: 'Rich in B vitamins and minerals' },
      { name: 'Lions Mane', amount: '266mg', description: 'Enhances cognitive function and clarity' },
      { name: 'Proprietary Blend', amount: '266mg', description: 'Maitake, Turkey Tails, Chaga, Royal Sun Agaricus, White Button, Wood Ear' }
    ],
    ingredientsSimple: [
      'Cordyceps Powder (266mg)',
      'Reishi Mushroom Extract (266mg)',
      'Shiitake Mushroom Extract (266mg)',
      'Lions Mane (266mg)',
      'Proprietary Blend (266mg): Maitake, Turkey Tails, Chaga, Royal Sun Agaricus, White Button, Wood Ear'
    ],
    benefits: [
      'Instant focus & lasting energy',
      'Enhanced mental clarity',
      'Sustained energy without crash',
      'Immune system support',
      'Adaptogenic stress support'
    ],
    usage: 'Take 2 capsules 20-30 minutes before your first meal of the day with an 8 fl oz of water or with your favorite beverage.',
    warnings: [
      'Do not exceed recommended dose',
      'Consult physician if pregnant, nursing, or have medical conditions',
      'Keep out of reach of children',
      'Store in a cool, dry place'
    ]
  },  synaptiq: {
    id: 'synaptiq',
    title: 'SYNAPTIQ',
    subtitle: 'Neuro Performance Boost',
    description: 'Advanced nootropic formula with comprehensive vitamin complex and proprietary blend for enhanced cognitive function, memory support, and neural performance.',
    price: 48.99,
    originalPrice: 68.99,
    image: '/products/snaptiq-1.png',
    images: ['/products/snaptiq-1.png', '/products/snaptic-2.png', '/products/snaptiq-3.png'],
    servingSize: '2 Capsules',
    servingsPerContainer: 30,
    supplyDays: 30,
    sku: '47033-812',
    ingredients: [
      { name: 'Proprietary Blend', amount: '609mg', description: 'DMAE Bitartrate, L-Glutamine, Glutamic Acid, Green Tea Extract, Bacopa Extract, Inositol, GABA, DHA 14%, Phosphatidylserine, Huperzine A' },
      { name: 'Complete Vitamin Complex', amount: 'Various', description: 'Vitamins A, C, D, E, complete B-Complex including B6, B12, Folate' },
      { name: 'Essential Minerals', amount: 'Various', description: 'Calcium, Iron, Magnesium, Zinc, Selenium, Copper, Manganese' },
      { name: 'Choline', amount: '50mg', description: 'Supports brain health and cognitive function' },
      { name: 'Biotin', amount: '3mcg', description: 'Essential for metabolism and neural function' }
    ],
    ingredientsSimple: [
      'Proprietary Blend (609mg): DMAE Bitartrate, L-Glutamine, Glutamic Acid, Green Tea Extract, Bacopa Extract',
      'Complete Vitamin Complex (A, C, D, E, B-Complex)',
      'Essential Minerals (Calcium, Iron, Magnesium, Zinc)',
      'DHA (Docosahexaenoic Acid) 14%',
      'Phosphatidylserine & Huperzine A'
    ],
    benefits: [
      'Neuro performance boost',
      'Enhanced memory and recall',
      'Improved learning capacity',
      'Complete daily nutrition support',
      'Mental clarity and focus'
    ],
    usage: 'Take 2 capsules 20-30 minutes before your first meal of the day with an 8 fl oz of water or with your favorite beverage.',
    warnings: [
      'Contains Soy & Fish (Tuna Fish)',
      'Accidental overdose of iron-containing products is a leading cause of fatal poisoning in children under 6',
      'Keep out of reach of children',
      'Consult physician before use if pregnant, nursing, or have medical conditions'
    ]
  },  vitra: {
    id: 'vitra',
    title: 'VITRA',
    subtitle: 'Brain Body Balance',
    description: 'Premium organic mushroom powder blend with herbal adaptogens for comprehensive wellness, mental clarity, and resilient health.',
    price: 58.99,
    originalPrice: 78.99,
    image: '/products/vitra-1.png',
    images: ['/products/vitra-1.png', '/products/vitra-2.png', '/products/vitra-3.png'],
    servingSize: '1 Scoop (1.96g)',
    servingsPerContainer: 60,
    supplyDays: 60,
    sku: '47035-862',
    form: 'Powder',
    netWeight: '4.2oz (117g)',
    ingredients: [
      { name: 'Organic Lions Mane Extract', amount: '350mg', description: 'Premium cognitive support from mycelium and fruiting bodies' },
      { name: 'Organic Reishi Mushroom Extract', amount: '200mg', description: 'The "mushroom of immortality" for immune and stress support' },
      { name: 'Organic Cordyceps Extract', amount: '200mg', description: 'Energy and endurance enhancement' },
      { name: 'Organic Shiitake Extract', amount: '200mg', description: 'Immune support and cardiovascular health' },
      { name: 'Organic Turkey Tail Extract', amount: '125mg', description: 'Powerful immune system support' },
      { name: 'Organic Maitake Extract', amount: '125mg', description: 'Blood sugar and immune support' },
      { name: 'Organic Chaga Extract', amount: '150mg', description: 'Antioxidant powerhouse' },
      { name: 'Herbal Adaptogen Blend', amount: '600mg', description: 'Organic Ashwagandha, Asian Ginseng, and Rhodiola for stress resilience' }
    ],
    ingredientsSimple: [
      'Organic Lions Mane Extract (350mg)',
      'Organic Reishi Mushroom Extract (200mg)',
      'Organic Cordyceps Extract (200mg)',
      'Organic Shiitake Extract (200mg)',
      'Herbal Adaptogen Blend (600mg): Ashwagandha, Asian Ginseng, Rhodiola'
    ],
    benefits: [
      'Brain and body balance',
      'Stress adaptation support',
      'Enhanced overall vitality',
      'Immune system fortification',
      'Natural energy without crashes',
      'Mental clarity and focus'
    ],
    usage: 'Adults, take one scoop (1.96g) with 8 ounces of water or your favorite hot or cold recipe. Can be mixed into smoothies, coffee, or tea.',
    warnings: [
      'If pregnant, nursing, allergic, or have medical conditions, consult doctor before use',
      'Do not use if product has been opened or tampered with',
      'Keep out of reach of children',
      'Store in a cool, dry place'
    ],
    features: [
      '100% Organic Mushroom Extracts',
      'No fillers or artificial ingredients',
      'Natural Bitter Blocker included',
      'Versatile powder form for easy mixing'
    ]
  }
};